export default "__VITE_ASSET__CPPnOkco__"